import { ActivatedRouteSnapshot } from '@angular/router';

/** Where the user is, in terms of the route table rather than the concrete URL. */
export interface RouteInfo {
  /** e.g. `/cash/bank-account` or `/hr/employee/:id` — parameters stay as `:name`, never their values. */
  template: string;
  /** The `module` from the route's data (e.g. `cash`), if any. */
  module: string;
}

/**
 * Builds the route template of the deepest active route by joining each level's configured
 * path. Using the configured path (not the URL) keeps employee ids, voucher numbers and other
 * parameters out of the activity stream.
 */
export function routeInfo(root: ActivatedRouteSnapshot): RouteInfo {
  const segments: string[] = [];
  let module = '';
  for (let r: ActivatedRouteSnapshot | null = root; r; r = r.firstChild) {
    const path = r.routeConfig?.path;
    if (path) segments.push(path);
    const m = r.data?.['module'];
    if (typeof m === 'string' && m) module = m;
  }
  return { template: '/' + segments.join('/'), module };
}
